"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/Button/index'));

//# sourceMappingURL=Button.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./Button.js
 ** module id = 52
 ** module chunks = 0
 **/